import clsx from "clsx";
import { useState, ReactNode } from "react";

import { Button } from "./button";

export type AccordionProps = {
  label: string;
  children: ReactNode;
  defaultOpen?: boolean;
  expandedClassName?: string;
};

export const Accordion = ({
  label,
  children,
  defaultOpen = false,
  expandedClassName = "max-h-[60rem]",
}: AccordionProps) => {
  const [expanded, setExpanded] = useState(defaultOpen);

  const toggleAccordion = () => {
    if (expanded) {
      setExpanded(false);
    } else {
      setExpanded(true);
    }
  };

  return (
    <div className="bg-white">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        className={clsx(
          "flex items-center justify-between cursor-pointer px-[1.6rem]",
          !expanded && "border-b border-neutral-100",
        )}
        onClick={() => toggleAccordion()}
      >
        <span className="text-ui font-semibold">{label}</span>
        <Button
          variant="secondarySubtle"
          leftIcon={expanded ? "regularAngleUp" : "regularAngleDown"}
        />
      </div>
      <div
        aria-hidden={!expanded}
        className={clsx(
          "overflow-hidden px-[2.4rem] transition-max-height transition-padding duration-300 ease-in-out",
          expanded
            ? `${expandedClassName} py-[1.6rem] border-b border-neutral-100`
            : "max-h-0 py-0",
        )}
      >
        {children}
      </div>
    </div>
  );
};
